<div class="footer d-flex flex-row align-items-center">
  <div class="row w-100">
    <div class="col-sm-4 offset-sm-2 col-12 my-5">
      <a [routerLink]="'/'">
        <img
          alt="Agenzia Italiana del Farmaco"
          i18n-alt="Alt per logo AIFA|Sezione footer"
          src="assets/images/AIFA2021_Neg_Col(HR) 1@2x.svg"
          class="image"
          style="width: 180px"
        />
      </a>
    </div>
    <!--INIZIO LINK FOOTER-->
    <div class="row my-3">
      <div class="col-12 col-sm-3 offset-sm-2">
        <div class="link-list-wrapper">
          <div class="link-list-heading p-0 mb-3">
            <span
              class="footer-link"
              i18n="titolo agenzia|footer@@footer.title-text.agenzia"
              >L'AGENZIA</span
            >
          </div>
          <ul class="link-list">
            <li>
              <a
                class="list-item p-0"
                href="https://www.aifa.gov.it/home"
              >
                <span class="list-item-title-icon-wrapper">
                  <div class="icon-container">
                    <span
                      class="list-item-title footer-link me-1"
                      i18n="
                        testo home page|lista footer@@footer.link-text.home-page"
                      >Home Page</span
                    >
                    <svg class="icon icon-sm accent-icon">
                      <use
                        href="assets/icons/right_2.svg#Icons/darkgreen/right"
                      ></use>
                    </svg>
                  </div>
                </span>
              </a>
            </li>
            <li>
              <a
                class="list-item p-0 mt-2"
                href="https://www.aifa.gov.it/farmaciline"
              >
                <span class="list-item-title-icon-wrapper">
                  <div class="icon-container">
                    <span
                      class="list-item-title footer-link me-1"
                      i18n="
                        testo farmaci line| lista
                        footer@@footer.link-text.farmaci-line"
                      >FarmaciLine</span
                    >
                    <svg class="icon icon-sm accent-icon">
                      <use
                        href="assets/icons/right_2.svg#Icons/darkgreen/right"
                      ></use>
                    </svg>
                  </div>
                </span>
              </a>
            </li>
            <li>
              <a
                class="list-item p-0 mt-2"
                href="https://www.aifa.gov.it/partecipazione-e-soddisfazione-utenti"
              >
                <span class="list-item-title-icon-wrapper">
                  <div class="icon-container">
                    <span
                      class="list-item-title footer-link me-1"
                      i18n="
                        testo Partecipazione e soddisfazione utenti|lista
                        footer@@footer.link-text.partecipazione-soddisfazione-utenti"
                      >Partecipazione e soddisfazione utenti</span
                    >
                    <svg class="icon icon-sm accent-icon">
                      <use
                        href="assets/icons/right_2.svg#Icons/darkgreen/right"
                      ></use>
                    </svg>
                  </div>
                </span>
              </a>
            </li>
            <li>
              <a
                class="list-item p-0 mt-2"
                href="https://www.aifa.gov.it/accesso-civico"
              >
                <span class="list-item-title-icon-wrapper">
                  <div class="icon-container">
                    <span
                      class="list-item-title footer-link me-1"
                      i18n="
                        testo Accesso civico|lista
                        footer@@footer.link-text.accesso-civico"
                      >Accesso civico</span
                    >
                    <svg class="icon icon-sm accent-icon">
                      <use
                        href="assets/icons/right_2.svg#Icons/darkgreen/right"
                      ></use>
                    </svg>
                  </div>
                </span>
              </a>
            </li>
            <li>
              <a
                class="list-item p-0 mt-2"
                href="https://www.aifa.gov.it/modulistica"
              >
                <span class="list-item-title-icon-wrapper">
                  <div class="icon-container">
                    <span
                      class="list-item-title footer-link me-1"
                      i18n="
                        testo Modulistica|lista
                        footer@@footer.link-text.modulistica"
                      >Modulistica</span
                    >
                    <svg class="icon icon-sm accent-icon">
                      <use
                        href="assets/icons/right_2.svg#Icons/darkgreen/right"
                      ></use>
                    </svg>
                  </div>
                </span>
              </a>
            </li>
            <li>
              <a
                class="list-item p-0 mt-2"
                href="https://www.aifa.gov.it/amministrazione-trasparente"
              >
                <span class="list-item-title-icon-wrapper">
                  <div class="icon-container">
                    <span
                      class="list-item-title footer-link me-1"
                      i18n="
                        testo Amministrazione Trasparente|lista
                        footer@@footer.link-text.amministrazione-trasparente"
                      >Amministrazione Trasparente</span
                    >
                    <svg class="icon icon-sm accent-icon">
                      <use
                        href="assets/icons/right_2.svg#Icons/darkgreen/right"
                      ></use>
                    </svg>
                  </div>
                </span>
              </a>
            </li>
            <li>
              <a
                class="list-item p-0 mt-2"
                href="https://www.aifa.gov.it/atti-di-notifica"
              >
                <span class="list-item-title-icon-wrapper">
                  <div class="icon-container">
                    <span
                      class="list-item-title footer-link me-1"
                      i18n="
                        testo Atti di notifica|lista
                        footer@@footer.link-text.atti-di-notifica"
                      >Atti di notifica</span
                    >
                    <svg class="icon icon-sm accent-icon">
                      <use
                        href="assets/icons/right_2.svg#Icons/darkgreen/right"
                      ></use>
                    </svg>
                  </div>
                </span>
              </a>
            </li>
            <li>
              <a
                class="list-item p-0 mt-2"
                href="https://www.aifa.gov.it/determine"
              >
                <span class="list-item-title-icon-wrapper">
                  <div class="icon-container">
                    <span
                      class="list-item-title footer-link me-1"
                      i18n="
                        testo Pubblicità legale|lista
                        footer@@footer.link-text.pubblicita-legale"
                      >Pubblicità legale</span
                    >
                    <svg class="icon icon-sm accent-icon">
                      <use
                        href="assets/icons/right_2.svg#Icons/darkgreen/right"
                      ></use>
                    </svg>
                  </div>
                </span>
              </a>
            </li>
            <li>
              <a
                class="list-item p-0 mt-2"
                href="https://trovanorme.aifa.gov.it/#/"
              >
                <span class="list-item-title-icon-wrapper">
                  <div class="icon-container">
                    <span
                      class="list-item-title footer-link me-1"
                      i18n="
                        testo TrovaNormeFarmaco|lista
                        footer@@footer.link-text.trova-norme-farmaco"
                      >TrovaNormeFarmaco</span
                    >
                    <svg class="icon icon-sm accent-icon">
                      <use
                        href="assets/icons/right_2.svg#Icons/darkgreen/right"
                      ></use>
                    </svg>
                  </div>
                </span>
              </a>
            </li>
            <li>
              <a
                class="list-item p-0 mt-2"
                href="https://www.aifa.gov.it/bandi-di-concorso"
              >
                <span class="list-item-title-icon-wrapper">
                  <div class="icon-container">
                    <span
                      class="list-item-title footer-link me-1"
                      i18n="
                        testo Bandi di Concorso|lista
                        footer@@footer.link-text.bandi-di-concorso"
                      >Bandi di Concorso</span
                    >
                    <svg class="icon icon-sm accent-icon">
                      <use
                        href="assets/icons/right_2.svg#Icons/darkgreen/right"
                      ></use>
                    </svg>
                  </div>
                </span>
              </a>
            </li>
            <li>
              <a
                class="list-item p-0 mt-2"
                href="https://www.aifa.gov.it/bandi-di-gara-e-contratti"
              >
                <span class="list-item-title-icon-wrapper">
                  <div class="icon-container">
                    <span
                      class="list-item-title footer-link me-1"
                      i18n="
                        testo Bandi di Gara e Contratti|lista
                        footer@@footer.link-text.bandi-di-gara-e-contratti"
                      >Bandi di Gara e Contratti</span
                    >
                    <svg class="icon icon-sm accent-icon">
                      <use
                        href="assets/icons/right_2.svg#Icons/darkgreen/right"
                      ></use>
                    </svg>
                  </div>
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-12 col-sm-3">
        <div class="link-list-wrapper">
          <div class="link-list-heading p-0 mb-3">
            <span
              class="footer-link"
              i18n="titolo contatti|footer@@footer.title-text.contatti"
              >CONTATTI</span
            >
          </div>
          <ul class="link-list">
            <li class="list-item p-0">
              <span class="list-item-title-icon-wrapper">
                <span
                  class="list-item-title footer-link me-1"
                  i18n="
                    testo indirizzo|lista footer@@footer.link-text.indirizzo"
                  >Via del Tritone, 181 00187 Roma</span
                >
              </span>
            </li>
            <li class="mt-2">
              <a
                class="list-item p-0"
                href="https://www.aifa.gov.it/contatti"
              >
                <span class="list-item-title-icon-wrapper">
                  <div class="icon-container">
                    <span
                      class="list-item-title footer-link me-1"
                      i18n="
                        testo contatti| lista footer@@footer.link-text.contatti"
                      >Contatti</span
                    >
                    <svg class="icon icon-sm accent-icon">
                      <use
                        href="assets/icons/right_2.svg#Icons/darkgreen/right"
                      ></use>
                    </svg>
                  </div>
                </span>
              </a>
            </li>
            <li class="mt-2">
              <a
                class="list-item p-0"
                href="https://www.aifa.gov.it/contatti-pec"
              >
                <span class="list-item-title-icon-wrapper">
                  <div class="icon-container">
                    <span
                      class="list-item-title footer-link me-1"
                      i18n="
                        testo Contatti PEC|lista
                        footer@@footer.link-text.contatti-pec"
                      >Contatti PEC</span
                    >
                    <svg class="icon icon-sm accent-icon">
                      <use
                        href="assets/icons/right_2.svg#Icons/darkgreen/right"
                      ></use>
                    </svg>
                  </div>
                </span>
              </a>
            </li>
            <li class="list-item p-0 mt-3" href="#">
              <span class="list-item-title-icon-wrapper">
                <span
                  class="list-item-title footer-link me-1"
                  i18n="
                    testo Partita IVA|lista footer@@footer.link-text.partita-iva"
                  >Partita IVA: 08703841000</span
                >
              </span>
            </li>
            <li class="list-item p-0 mt-2" href="#">
              <span class="list-item-title-icon-wrapper">
                <span
                  class="list-item-title footer-link me-1"
                  i18n="
                    testo Codice Fiscale|lista
                    footer@@footer.link-text.codice-fiscale"
                  >Codice Fiscale: 97345810580</span
                >
              </span>
            </li>
            <li class="list-item p-0 mt-2" href="#">
              <span class="list-item-title-icon-wrapper">
                <span
                  class="list-item-title footer-link me-1"
                  i18n="
                    testo Codice IPA AIFA|lista
                    footer@@footer.link-text.codice-ipa-aifa"
                  >Codice IPA AIFA: aifa_rm</span
                >
              </span>
            </li>
            <li class="list-item p-0 mt-2" href="#">
              <span class="list-item-title-icon-wrapper">
                <span
                  class="list-item-title footer-link me-1"
                  i18n="
                    testo Codice IPA UCB|lista
                    footer@@footer.link-text.codice-ipa-ucb"
                  >Codice IPA UCB: UFE1TR</span
                >
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-12 col-sm-3">
        <div class="link-list-wrapper">
          <div class="link-list-heading p-0">
            <span
              class="footer-link"
              i18n="testo seguici|lista footer@@footer.title-text.seguici-su"
              >SEGUICI SU</span
            >
          </div>
          <ul class="link-list">
            <li class="list-item p-0" href="#">
              <div class="multi-icon-container">
                <a class="p-0" href="https://www.facebook.com/AIFAufficiale/">
                  <em
                    i18n-aria-label="
                      Label per Collegamento facebook|Sezione Social
                      footer@@footer.link-icon.facebook"
                    aria-label="Collegamento facebook"
                    class="fa fa-facebook fa-2x"
                  ></em>
                </a>
                <a class="p-0" href="https://twitter.com/Aifa_ufficiale">
                  <em
                    i18n-aria-label="
                      Label per Collegamento Twitter|Sezione Social
                      footer@@footer.link-icon.twitter"
                    aria-label="Collegamento Twitter"
                    class="fa fa-twitter fa-2x"
                  ></em>
                </a>
                <a
                  class="p-0"
                  href="https://www.youtube.com/channel/UCMDgZt1zx9-Kwr0811jY4PQ"
                >
                  <em
                    i18n-aria-label="
                      Label per Collegamento Youtube|Sezione Social
                      footer@@footer.link-icon.youtube"
                    aria-label="Collegamento Youtube"
                    class="fa fa-youtube fa-2x"
                  ></em>
                </a>
                <a class="p-0" href="https://it.linkedin.com/company/aifa-agenzia-italiana-del-farmaco">
                  <em
                    i18n-aria-label="
                      Label per Collegamento Linkedin|Sezione Social
                      footer@@footer.link-icon.linkedin"
                    aria-label="Collegamento Linkedin"
                    class="fa fa-linkedin fa-2x"
                  ></em>
                </a>
                <a
                  class="p-0"
                  href="https://www.instagram.com/aifa_agenziafarmaco/"
                >
                  <em
                    i18n-aria-label="
                      Label per Collegamento Instagram|Sezione Social
                      footer@@footer.link-icon.instagram"
                    aria-label="Collegamento Instagram"
                    class="fa fa-instagram fa-2x"
                  ></em>
                </a>
                <a
                  class="p-0"
                  href="https://open.spotify.com/show/3VoGZXBNgmtREOgL5dgSYP"
                >
                  <em
                    i18n-aria-label="
                      Label per Collegamento Spotify|Sezione Social
                      footer@@footer.link-icon.spotify"
                    aria-label="Collegamento Spotify"
                    class="fa fa-spotify fa-2x"
                  ></em>
                </a>
              </div>
            </li>
          </ul>
          <div class="link-list-heading p-0">
            <span
              class="footer-link"
              i18n="testo FEED RSS| lista footer@@footer.link-text.feed-rss"
              >FEED RSS</span
            >
          </div>
          <ul>
            <li>
              <a class="p-0" href="https://www.aifa.gov.it/feed-rss">
                <em
                  i18n-aria-label="
                    Label per Collegamento feed-rss|Sezione
                    feed-rss@@footer.link-icon.feed-rss"
                  aria-label="Collegamento feed-rss"
                  class="fa fa-rss-square fa-lg"
                ></em>
              </a>
            </li>
          </ul>
          <ul>
            <li>
                <a
                  class="list-item p-0 mt-2"
                  href="https://www.aifa.gov.it/mobile-app-aifa"
                >
                  <span class="list-item-title-icon-wrapper">
                    <div class="icon-container">
                      <svg class="icon icon-primary sm-2">
                        <use
                          href="assets/icons/ic_mobile.svg#ic_mobile"
                        ></use>
                      </svg>
                      <span
                        class="list-item-title footer-link me-1"
                        i18n="
                          testo Scarica l’APP Medicinali AIFA|lista
                          footer@@footer.link-text.mobile-app-aifa"
                        >Scarica l’APP Medicinali AIFA</span
                      >
                      <svg class="icon icon-sm accent-icon">
                        <use
                          href="assets/icons/right_2.svg#Icons/darkgreen/right"
                        ></use>
                      </svg>
                    </div>
                  </span>
                </a>
              </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- FINE LINK FOOTER-->
  </div>
</div>

<div class="second-footer d-flex align-items-center bg-primary">
  <div class="container">
    <div
      class="d-flex py-3 py-md-0 flex-column flex-md-row align-items-md-center justify-content-around flex-wrap gap-2"
    >
      <a
        class="link-styling"
        href="https://www.aifa.gov.it/copyright"
        i18n="note legali|secondo footer"
        >Note legali</a
      >
      <a
        class="link-styling"
        href="https://www.aifa.gov.it/informazione-e-comunicazione"
        i18n="Social Media Policy|secondo footer"
        >Social Media Policy</a
      >
      <a
        class="link-styling"
        href="https://form.agid.gov.it/view/df78cec2-8365-4ed4-8eb5-0b9333b3696d/"
        i18n="Dichiarazione di accessibilità|secondo footer"
        >Dichiarazione di accessibilità</a
      >
      <a
        class="link-styling"
        href="https://www.aifa.gov.it/obiettivi-di-accessibilit%C3%A0"
        i18n="Obiettivi di accessibilità|secondo footer"
        >Obiettivi di accessibilità</a
      >
      <a
        class="link-styling"
        href="https://www.aifa.gov.it/dati-monitoraggio"
        i18n="Statistiche sito|secondo footer"
        >Statistiche sito</a
      >
      <a
        class="link-styling"
        href="https://www.aifa.gov.it/privacy"
        i18n="Privacy|secondo footer"
        >Privacy</a
      >
      <a
        class="link-styling"
        href="https://servizionline.aifa.gov.it/"
        i18n="Servizi Online|secondo footer"
        >Servizi Online</a
      >
    </div>
  </div>
</div>
